import CPP from "../assets/cpp.png";
import C from "../assets/c.png";
import CSharp from "../assets/c-sharp.png";
import Python from "../assets/python.png";
import Java from "../assets/java.png";
import JavaScript from "../assets/javascript.png"
import SQL from "../assets/sql.png";
import HTML from "../assets/html5.png";
import CSS from "../assets/css.png";
import React from "../assets/react.png";
import MySQL from "../assets/mysql.png";
import Git from "../assets/git.png";
import Docker from "../assets/docker.png";
import Kubernetes from "../assets/kubernetes.png";
import UnrealEngine from "../assets/unreal-engine.png";
import Unity from "../assets/unity.png";
import TensorFlow from "../assets/tensor-flow.png";

const programmingSkills = [
    { imageUrl: CPP, altText: 'cpplogo', name: 'C++', proficiency: ' ' },
    { imageUrl: Java, altText: 'javalogo', name: 'Java', proficiency: ' ' },
    { imageUrl: C, altText: 'clogo', name: 'C', proficiency: ' ' },
    { imageUrl: CSharp, altText: 'csharplogo', name: 'C#', proficiency: ' ' },
    { imageUrl: Python, altText: 'pythonlogo', name: 'Python', proficiency: ' ' },
    { imageUrl: JavaScript, altText: 'jslogo', name: 'JavaScript', proficiency: ' ' },
];

const otherSkills = [
    { imageUrl: HTML, altText: 'html5logo', name: 'HTML', proficiency: ' ' },
    { imageUrl: CSS, altText: 'csslogo', name: 'CSS', proficiency: ' ' },
    { imageUrl: React, altText: 'reactlogo', name: 'React', proficiency: ' ' },
    { imageUrl: Git, altText: 'gitlogo', name: 'Git', proficiency: ' ' },
    { imageUrl: Docker, altText: 'dockerlogo', name: 'Docker', proficiency: ' ' },
    { imageUrl: Kubernetes, altText: 'kuberneteslogo', name: 'Kubernetes', proficiency: ' ' },
    { imageUrl: UnrealEngine, altText: 'unrealenginelogo', name: 'Unreal Engine', proficiency: ' ' },
    { imageUrl: Unity, altText: 'unitylogo', name: 'Unity', proficiency: ' ' },
    { imageUrl: TensorFlow, altText: 'tensorflowlogo', name: 'TensorFlow', proficiency: ' ' },
];
  
export { programmingSkills, otherSkills };